import { useEffect, useState } from "react";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import { fetchPartnerCategories, fetchPartnerDisclosures, fetchPartnerRouting } from "../../../services/automapPartnershipApi";
import { AdminPartnersNav } from "./AdminPartnersShared";

export function AdminPartnerCategoriesPage() {
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    fetchPartnerCategories().then((d) => setCategories(d.categories || []));
  }, []);
  return (
    <AdminPageLayout>
      <AdminPageHeader eyebrow="AutoMapa · Aliados" title="Categorías de servicio" description="Configuración de categorías (read-only MVP)." />
      <AdminAutomotiveNav active="partners" />
      <AdminPartnersNav active="categories" />
      <main className="admin-console__main wrap">
        <p className="muted">TODO: editable category settings (routing defaults, CTA locations).</p>
        <div className="import-table-wrap">
          <table className="import-table">
            <thead><tr><th>Categoría</th><th>Label</th><th>Aliados activos</th><th>Página pública</th><th>CTAs</th></tr></thead>
            <tbody>
              {categories.map((c) => (
                <tr key={c.category}>
                  <td>{c.category}</td>
                  <td>{c.labelEs}</td>
                  <td>{c.activePartners}</td>
                  <td>{c.publicServicePageEnabled ? "Sí" : "No"}</td>
                  <td>{(c.ctaLocationsEnabled || []).join(", ")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>
    </AdminPageLayout>
  );
}

export function AdminPartnerRoutingPage() {
  const [routing, setRouting] = useState(null);
  useEffect(() => {
    fetchPartnerRouting().then((d) => setRouting(d.routing));
  }, []);
  return (
    <AdminPageLayout>
      <AdminPageHeader eyebrow="AutoMapa · Aliados" title="Reglas de routing" />
      <AdminAutomotiveNav active="partners" />
      <AdminPartnersNav active="routing" />
      <main className="admin-console__main wrap">
        {routing ? (
          <>
            <p>{routing.description}</p>
            <p><strong>Factores:</strong> {routing.factors?.join(", ")}</p>
            <p><strong>Round-robin:</strong> {routing.roundRobinPlaceholder ? "Placeholder" : "No"}</p>
            <p><strong>Entrega externa automática:</strong> {routing.automaticExternalDelivery ? "Sí" : "No (manual MVP)"}</p>
            <ul>{Object.entries(routing.activePartnersByCategory || {}).map(([k, v]) => <li key={k}>{k}: {v} activos</li>)}</ul>
          </>
        ) : <p>Cargando…</p>}
      </main>
    </AdminPageLayout>
  );
}

export function AdminPartnerDisclosuresPage() {
  const [disclosures, setDisclosures] = useState(null);
  useEffect(() => {
    fetchPartnerDisclosures().then((d) => setDisclosures(d.disclosures));
  }, []);
  return (
    <AdminPageLayout>
      <AdminPageHeader eyebrow="AutoMapa · Aliados" title="Divulgaciones" description="Texto seguro para compradores — evitar promesas de garantía." />
      <AdminAutomotiveNav active="partners" />
      <AdminPartnersNav active="disclosures" />
      <main className="admin-console__main wrap">
        {disclosures ? (
          <>
            <section className="dealer-state-box"><h3>General</h3><p>{disclosures.general}</p></section>
            {Object.entries(disclosures.categories || {}).map(([cat, text]) => (
              <section key={cat} className="dealer-state-box">
                <h3>{disclosures.categoryLabels?.[cat] || cat}</h3>
                <p>{text}</p>
              </section>
            ))}
          </>
        ) : <p>Cargando…</p>}
      </main>
    </AdminPageLayout>
  );
}
